import moment from 'moment';
import { Map } from 'immutable';
import VoicemailsResource from 'flow/api/voicemails';
import {
    networkErrorDispatcher,
    httpGetErrorDispatcher,
} from 'flow/actions/app-actions';
import { ISO_8601_MS_RESOLUTION } from 'flow/utils';

import Actions from 'flow/actions';

export const fetchVoicemailSettings = (entityKey) => (dispatch) => {
    VoicemailsResource.getSettings(
        {
            onResult(json) {
                dispatch(receiveVoicemailSettings(entityKey, json));
            },

            onClientError(request) {
                if (request.status === 404) {
                    dispatch(receiveVoicemailSettingsUnavailable(entityKey));
                }
            },
            onError: httpGetErrorDispatcher(dispatch),
        },
        entityKey,
    );
};

export const updateVoicemailSettings =
    (entityKey, voicemailSettingsDTO) => (dispatch) => {
        VoicemailsResource.updateSettings(
            {
                onResult(/*json*/) {
                    dispatch(
                        receiveVoicemailSettings(
                            entityKey,
                            voicemailSettingsDTO,
                        ),
                    );
                },

                onError: networkErrorDispatcher(dispatch),
            },
            voicemailSettingsDTO,
        );
    };

export const getVoiceMessageActions =
    (voicemailEntityKey, uniqueId) => (dispatch) => {
        VoicemailsResource.getVoiceMessageActions(
            {
                onResult(json) {
                    dispatch(
                        receiveVoiceMessageActions(
                            voicemailEntityKey,
                            uniqueId,
                            json,
                        ),
                    );
                },
                onError: networkErrorDispatcher(dispatch),
            },
            voicemailEntityKey,
            uniqueId,
            'contact',
        );
    };

export const createVoiceMessageAction =
    (voicemailEntityKey, uniqueId) => (dispatch, getState) => {
        const { app } = getState();
        const ownContact = app.getIn(['extension', 'contact'], Map()).toJS();
        const callActionDTO = {
            name: 'handle-unanswered',
            timestamp: moment().format(ISO_8601_MS_RESOLUTION),
        };
        VoicemailsResource.createVoiceMessageAction(
            {
                onResult(json) {
                    //Attach your contact to callAction so we can show info about the agent.
                    //The API request didnt have a request config param that includes the contact from the API.
                    json.agent.contact = ownContact;
                    dispatch(
                        receiveCreateVoiceMessageAction(
                            voicemailEntityKey,
                            uniqueId,
                            json,
                        ),
                    );
                },
                onError: networkErrorDispatcher(dispatch),
            },
            voicemailEntityKey,
            uniqueId,
            callActionDTO,
            'contact',
        );
    };

export const deleteVoiceMessageAction =
    (voicemailEntityKey, uniqueId, callActionKey) => (dispatch) => {
        VoicemailsResource.deleteVoiceMessageAction(
            {
                onResult() {
                    dispatch(
                        receiveDeleteVoiceMessageAction(
                            voicemailEntityKey,
                            uniqueId,
                            callActionKey,
                        ),
                    );
                },
                onError: networkErrorDispatcher(dispatch),
            },
            voicemailEntityKey,
            uniqueId,
            callActionKey,
        );
    };

const receiveVoiceMessageActions = (
    voicemailKey,
    voiceMessageKey,
    voiceMessageActions,
) => ({
    type: Actions.RESULT_GET_VOICEMAIL_ACTIONS,
    voicemailKey,
    voiceMessageKey,
    voiceMessageActions,
});

const receiveCreateVoiceMessageAction = (
    voicemailKey,
    voiceMessageKey,
    voiceMessageAction,
) => ({
    type: Actions.RESULT_CREATE_VOICEMAIL_ACTION,
    voicemailKey,
    voiceMessageKey,
    voiceMessageAction,
});

const receiveDeleteVoiceMessageAction = (
    voicemailKey,
    voiceMessageKey,
    callActionKey,
) => ({
    type: Actions.RESULT_DELETE_VOICEMAIL_ACTION,
    voicemailKey,
    voiceMessageKey,
    callActionKey,
});

const receiveVoicemailSettings = (entityKey, voicemailSettingsDTO) => ({
    type: Actions.RESULT_VOICEMAIL_SETTINGS,
    key: entityKey,
    data: voicemailSettingsDTO,
});

const receiveVoicemailSettingsUnavailable = (entityKey) => {
    return {
        type: Actions.RESULT_VOICEMAIL_SETTINGS_UNAVAILABLE,
        key: entityKey,
    };
};
